import { Icon, Text } from '@kanda-libs/ks-design-library';
import { HEADER_CLASS_NAMES, HEADER_PROPS } from './constants';

interface HeaderProps {
  isLoading?: boolean;
}

const Header = ({ isLoading }: HeaderProps) => {
  const innerItemProps = { isLoading };

  return (
    <div className={HEADER_CLASS_NAMES.container}>
      <Text {...HEADER_PROPS.title} {...innerItemProps} />
      <div className={HEADER_CLASS_NAMES.descriptionWrapper}>
        <Text {...HEADER_PROPS.description} {...innerItemProps} />
        <Icon {...HEADER_PROPS.icon} {...innerItemProps} />
      </div>
    </div>
  );
};

Header.displayName = 'ApplyForFinance-Desktop-Welcome-Header-view';

Header.defaultProps = {
  isLoading: false,
};

export default Header;
